<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="商品管理">
      <template>
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="newlyAdded"
          >新增商品</el-button
        >
        <el-button
          size="small"
          icon="el-icon-upload"
          type="primary"
          style="margin-left: 10px"
          @click="showImportDialog"
        >批量导入</el-button>
      </template>
    </pageTitle>
    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="editButton(row.row)">
            <i class="iconfont icon-bianji"></i> 编辑
          </div>
          <div class="button button_revoke" @click="switchingStates(row.row)">
            <i
              :class="
                row.row.status == 1
                  ? 'iconfont icon-lock'
                  : 'iconfont icon-jihuo'
              "
            ></i
            >{{ row.row.status == 0 ? "锁定" : "激活" }}
          </div>
          <div class="button button_revoke" @click="deleteRows(row.row)">
            <i class="iconfont icon-shanchu"></i> 删除
          </div>
          <!-- <el-popover
            :visible-arrow="false"
            placement="bottom"
            width="160"
            trigger="click"
          >
            <ul class="moreOperations">
              <li @click="activation(row.row)">
                <i class="iconfont icon-jihuo"></i> 上架
              </li>
              <li @click="deleteRows(row.row)">
                <i class="iconfont icon-shanchu"></i> 删除
              </li>
            </ul>
            <div slot="reference" class="button button_more">
              <img src="../../assets/images/icon_more.png" />
            </div>
          </el-popover> -->
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>

    <!-- 导入弹窗 -->
    <el-dialog title="批量导入" :visible.sync="importDialogVisible" width="500px">
      <div>
        <div class="upload-area" @click="triggerFileInput">
          <i class="el-icon-upload"></i>
          <div class="upload-text">
            将Excel文件拖到此处，或<em>点击上传</em>
          </div>
        </div>
        <input
          type="file"
          ref="fileInput"
          style="display: none"
          accept=".xlsx,.xls,.csv"
          @change="handleFileChange"
        />
        <div v-if="importFileName" class="import-file-name">
          <i class="el-icon-document"></i>
          已选择: {{ importFileName }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDownloadTemplate">下载模板</el-button>
        <el-button type="primary" @click="confirmImport" :disabled="!importFile">确认导入</el-button>
        <el-button @click="importDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  itemListGetList,
  itemListDel,
  itemListActive,
  itemListLock,
  itemClassGetList,
  itemListImportExcel,
  itemListGetTemplate,
} from "@/api/basicConfiguration";
import ItemVue from "../../components/layout/leftMenu/Item.vue";
import { getSession } from "@/utils/cookie";
import { getRoles } from "@/utils";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "platformProducts",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        search: [
          {
            label: "商品编号",
            type: "inputNumber",
            key: "id",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          {
            label: "分类",
            type: "treeselect",
            key: "class_id",
            options: [],
          },
          {
            label: "状态",
            key: "status",
            type: "select",
            options: [
              {
                label: "上架",
                value: 0,
              },
              {
                label: "下架",
                value: 1,
              },
            ],
          },
        ],
        data: [],
        column: [
          {
            label: "商品编号",
            prop: "id",
          },
          {
            label: "商品名称",
            prop: "name",
          },
          {
            label: "分类",
            prop: "class_name",
          },
          {
            label: "条码",
            prop: "item_number",
          },
          {
            label: "状态",
            prop: "status",
            filter: "upAndDownShelves",
          },
          {
            label: "在售/停售",
            prop: "sell_status",
            filter: "sellOrStopSell",
          },
          {
            label: "销量",
            prop: "sell_total",
          },
          {
            label: "更新时间",
            prop: "update_time",
            sortable: true,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      importDialogVisible: false,
      importFile: null,
      importFileName: '',
    };
  },
  created() {
    // 初始化列表内容
    this.getlist();
    this.obtainDataSource();
  },
  methods: {
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认下架?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemListLock({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认上架?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemListActive({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemListDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page) {
      if (page) {
        this.basicListconfig.page = page;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      itemListGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
    obtainDataSource() {
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 显示导入弹窗
    showImportDialog() {
      this.importDialogVisible = true;
      this.importFile = null;
      this.importFileName = '';
    },
    // 触发文件选择
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    // 处理文件选择
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      const fileType = file.type || '';
      const fileName = file.name.toLowerCase();
      const isExcelByType = fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                           fileType === 'application/vnd.ms-excel';
      const isExcelByExt = fileName.endsWith('.xlsx') ||
                          fileName.endsWith('.xls') ||
                          fileName.endsWith('.csv');
      const isExcel = isExcelByType || isExcelByExt;

      if (!isExcel) {
        this.$message.error('只能上传Excel文件或CSV文件!');
        this.importFile = null;
        this.importFileName = '';
        return;
      }

      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!');
        this.importFile = null;
        this.importFileName = '';
        return;
      }

      this.importFile = file;
      this.importFileName = file.name;
      this.$message.success('文件已选择: ' + file.name);
    },
    // 下载导入模板
    handleDownloadTemplate() {
      const apiBase = process.env.VUE_APP_BASE_API || 'https://erp.zuizhenshi.cn';
      const url = `${apiBase}/admin/item_list/getTemplate`;
      window.open(url, '_blank');
    },
    // 确认导入
    confirmImport() {
      if (!this.importFile) {
        this.$message.warning('请先选择要导入的Excel文件');
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: '正在导入...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const formData = new FormData();
      formData.append('file', this.importFile);

      itemListImportExcel(formData).then((res) => {
        loading.close();
        if (!res) {
          this.$message.error('导入失败: 服务器无响应');
          return;
        }
        if (res.code === 1) {
          this.$message.success('导入成功');
          this.importDialogVisible = false;
          this.getlist();
        } else if (res.code === 2 && res.file_url) {
          this.$confirm('导入部分成功，成功' + res.success_count + '条，失败' + res.fail_count + '条，是否下载失败记录？', '提示', {
            confirmButtonText: '下载',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            window.open(res.file_url, '_blank');
          }).catch(() => {});
        } else {
          this.$message.error('导入失败: ' + (res.msg || '未知错误'));
        }
      }).catch((error) => {
        loading.close();
        console.error('导入失败', error);
        this.$message.error('导入失败: ' + (error.message || '未知错误'));
      });
    },
  },
};
</script>

<style>
.upload-area {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background: #fafafa;
  padding: 40px 20px;
  cursor: pointer;
  transition: border-color 0.3s;
}

.upload-area:hover {
  border-color: #409eff;
}

.upload-area i {
  font-size: 48px;
  color: #8c939d;
  margin-bottom: 10px;
}

.upload-text {
  font-size: 14px;
  color: #8c939d;
}

.upload-text em {
  color: #409eff;
  font-style: normal;
}

.import-file-name {
  margin-top: 15px;
  padding: 10px 15px;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  color: #67c23a;
  font-size: 14px;
}

.import-file-name i {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/platformProducts/index.vue